import { useHomeBanner, useNewsCategoriesData, useLatestUpdatesPostData } from '@/src/api/getData';
import Banner from '@/components/banner';
// import { useParams } from 'react-router-dom';
import { useState } from 'react';
import sortByDate from '@/components/SortByDate';
import LatestUpdatesCards from '@/components/latestUpdatesCards';

const LatestUpdateView: any = ({ language = '' }) => {
    const { data: banner } = useHomeBanner(language);
    const { data: categories } = useNewsCategoriesData();
    const { data: latestUpdates } = useLatestUpdatesPostData(language);

    let categoriesData = categories?.data || [];
    let latestUpdatesData = latestUpdates?.data?.news_posts || [];

    // Sort by date (newest first)
    latestUpdatesData = sortByDate(latestUpdatesData);
    const [name, setName] = useState("all");

    return (
        <main className='theme-latest-update'>
            <Banner banner={banner} category="Latest Updates" />
            <div className="container" id="start">
                {/* Category Filter */}
                <div className={`category ${language == "en" ? "justify-between" : "gap-10"}`}>
                    {categoriesData && categoriesData.map((item: any, index: number) => {
                        return <div key={index} className={`category-item ${name === item.Name ? 'active' : ''}`} onClick={() => setName(item.Name)}>
                            {language == "en" ? item.Title : item.Zh_title}
                        </div>
                    })}
                </div>
                <div className="latest-update-content">
                    <LatestUpdatesCards latestUpdatesData={latestUpdatesData} language={language} name={name} />
                </div>
            </div>
        </main>
    );
}

export default LatestUpdateView;